export default __webpack_public_path__ + "static/media/guesty_lite_step4.6cca8305.png";